import React, { ChangeEvent, FC, useState } from 'react'
import cn from 'classnames'
import { ConfirmModal } from '../ConfirmModal'

import { toast } from 'App'
import { useStore } from 'store'
import { approveAmount } from 'utils/blockchain/ERC20'
import { checkStringNumber, isAvailableBlockchainProviderToast } from 'utils'

import { ReactComponent as CompanyIcon } from 'sources/images/companyIcon.svg'

import styles from './styles.module.scss'

interface IProps {
  isOpen: boolean,
  setIsOpen: (value: boolean) => void,
  onApproveAmountSuccess: () => void,
  approvedWalletBalance: number
  walletBalance: number
}

//Resize
//Resize for big screen dont need now
export const ApproveAmountModal: FC<IProps> = (
  {
    isOpen,
    setIsOpen,
    approvedWalletBalance,
    walletBalance,
    onApproveAmountSuccess
  }) => {
  const { loading, walletConnect, marketplace } = useStore()
  const [amount, setAmount] = useState('')

  const onSuccess = async (amount: number) => {
    await marketplace.updateApprovedAmount(amount)
    await onApproveAmountSuccess()
    toast({
      type: 'success',
      message: 'The amount was successfully approved'
    })
    setIsOpen(false)
    loading.setLoading(false)
  }

  const onError = async (message?: string) => {
    toast({
      type: 'error',
      message: message ? message : 'Approve amount error!!!!!!'
    })
    loading.setLoading(false)
  }

  const onApproveAmount = async () => {
    if (!isAvailableBlockchainProviderToast()) return
    if (Number(amount) < 0.1) {
      return toast({
        type: 'warning',
        message: 'The number cannot be less than 0.1'
      })
    }

    if (Number(amount) > (walletBalance - approvedWalletBalance)) {
      return toast({
        type: 'warning',
        message: 'You do not have this amount of AUTH in your wallet'
      })
    }

    loading.setLoading(true)
    const amountToBeApproved = Number(amount.replace(/,/g, '.'))
    await approveAmount(amountToBeApproved, onSuccess, onError)
  }


  const onChangeAmount = (e: ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target
    //Change input type to number
    if (checkStringNumber(value)) {
      setAmount(value)
    }
  }

  return (
    <ConfirmModal isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  onClickYes={onApproveAmount}
                  closeOnYes={false}
                  text={(
                    <div className={styles.modalBody}>
                      <div>
                        <div className={styles.modalTitle}>
                          Increase approved amount?
                        </div>
                        <div className={styles.topBlock}>
                          <div className={styles.balanceLabelBlock}>
                            <div className={styles.modalLabel}>Amount to be approved:</div>
                            <div className={styles.balance}>
                              Your wallet balance ${walletBalance} AUTH
                            </div>
                          </div>
                          <div className={styles.modalInputBody}>
                            <input
                              type="string"
                              value={amount}
                              onChange={onChangeAmount}
                              className={styles.modalInput}
                            />
                            <CompanyIcon/>
                          </div>
                        </div>

                        <div className={cn(styles.topBlock, styles.approvedBalance)}>
                          <div className={styles.balanceLabelBlock}>
                            <div className={styles.modalLabel}>Approved balance:</div>
                          </div>
                          <div className={styles.modalInputBody}>
                            <input
                              disabled
                              type="number"
                              value={approvedWalletBalance}
                              className={cn(styles.modalInput, styles.modalInputDisabled)}
                            />
                            <CompanyIcon/>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}/>
  )
}
